import * as Yup from "yup";
import { parseCurrencyString } from "@/utils/parseCurrencyString";

export const purchaseSchema = Yup.object().shape({
  product_id: Yup.mixed<number | string>()
    .transform((value) => (value === "" ? undefined : value))
    .when("$isWriteOff", {
      is: false,
      then: (schema) => schema.required("Produto é obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),

  supplier_id: Yup.mixed<number | string>().when("$isWriteOff", {
    is: false,
    then: (schema) => schema.required("Fornecedor é obrigatório"),
    otherwise: (schema) => schema.notRequired(),
  }),

  quantity: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? null : Number(originalValue),
    )
    .nullable()
    .typeError("Quantidade deve ser um número válido")
    .when("$isWriteOff", {
      is: false,
      then: (schema) =>
        schema
          .test(
            "is-required",
            "Quantidade é obrigatória",
            (value) => value !== null && value !== undefined,
          )
          .min(1, "Quantidade deve ser no mínimo 1"),
      otherwise: (schema) => schema.notRequired(),
    }),

  payment_method_id: Yup.mixed<number | string>()
    .transform((value) => (value === "" ? undefined : value))
    .required("Forma de pagamento é obrigatória"),

  amount: Yup.string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),

  expiration_date: Yup.string()
    .transform((value) => (value ? value.trim() : null))
    .when("$isWriteOff", {
      is: false,
      then: (schema) =>
        schema
          .required("Data de vencimento obrigatória")
          .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato inválido (YYYY-MM-DD)"),

      otherwise: (schema) => schema.notRequired(),
    }),

  payment_date: Yup.string().when("$isWriteOff", {
    is: true,
    then: (schema) =>
      schema
        .required("Data de pagamento é obrigatória")
        .matches(/^\d{4}-\d{2}-\d{2}$/, "Formato inválido (YYYY-MM-DD)"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
